import { render, staticRenderFns } from "./ProjectTemplate.vue?vue&type=template&id=4cdb69f0&scoped=true&"
import script from "./ProjectTemplate.vue?vue&type=script&lang=js&"
export * from "./ProjectTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTemplate.vue?vue&type=style&index=0&id=4cdb69f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdb69f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VFadeTransition } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VContainer,
  VContent,
  VFadeTransition,
})
